export default __webpack_public_path__ + "static/media/LogoSoho.4a4b51d0.svg";